import { BaseBudgetInput } from "../../components/budget/BaseBudgetInput";
import { _ACTIVITIES, _ROLES_BACK } from "../../utils/constants";
import { _ROUTES } from "../../utils/_routes_constants";
import AgGridSalesBlock from "../../components/budget/sales-block/AgGridSalesBlock";
import { useEffect, useState } from "react";
import { sendToFinancialData } from "../../components/budget/BaseBudgetSaveFunctions";
import {
  _SAVE_CATEGORY_SALES_BLOCK,
  _SAVE_DATA_SALES_BLOCK,
  _SAVE_HANDLE_SALES_BLOCK_THEME,
} from "../../utils/constantsSave";

const InputSaleBlock = () => {
  const [saveData, setSaveData] = useState([]);
  const arrayData = _SAVE_DATA_SALES_BLOCK;
  const save_name_category = _SAVE_CATEGORY_SALES_BLOCK;
  const [params, setParams] = useState({});

  useEffect(() => {
    if (saveData.length > 0) {
      const modifiedData = saveData?.map((d) => {
        if (
          d?.subThemes != undefined &&
          _SAVE_HANDLE_SALES_BLOCK_THEME[d.subThemes] !== undefined
        ) {
          const payload = {
            activityName: _ACTIVITIES.BLOCK,
            siteId: params.site,
            theme: _SAVE_HANDLE_SALES_BLOCK_THEME[d.subThemes],
            months: {},
          };

          for (let i = 1; i <= 12; i++) {
            payload.months[i] = d[i] || null;
          }

          return payload;
        }
      });
      sendToFinancialData(modifiedData, save_name_category);
    }
  }, [saveData]);

  return (
    <>
      <BaseBudgetInput
        title="Input Sales Block"
        roles={[_ROLES_BACK._ROLE_ADMIN, _ROLES_BACK._ROLE_CTRL]}
        userRole={_ROLES_BACK._ROLE_SALES}
        enableFlag="dataEntryEnableSales"
        TableComponent={AgGridSalesBlock}
        includeBaseBudgetSave={true}
        saveData={saveData}
        setSaveData={setSaveData}
        arrayData={arrayData}
        saveNameCategory={save_name_category}
        onParamsChange={setParams}
        filters={[
          {
            key: "site",
            route: _ROUTES.SITES,
            defaultValue: "",
            label: "Site",
            queryParams: {
              active: 1,
              "activities.code": _ACTIVITIES["BLOCK"],
            },
          },
        ]}
      />
    </>
  );
};

export default InputSaleBlock;
